import React, { FunctionComponent } from 'react';

import { PeopleDetailSection } from '../PeopleDetailSection/PeopleDetailSection';

export const PeopleDetailSkills: FunctionComponent = ({ children }) => {
  return <PeopleDetailSection title="Skills">{children}</PeopleDetailSection>;
};

export default PeopleDetailSkills;
